import React from "react";
import { Col, KeyValue, Row } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export var FieldRow = function (_a) {
    var labelId = _a.labelId, value = _a.value, _b = _a.marginBottom, marginBottom = _b === void 0 ? 25 : _b;
    return (React.createElement(Row, { style: { marginBottom: "".concat(marginBottom, "px") } },
        React.createElement(Col, { xs: 12 },
            React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: labelId }), value: value != null
                    ? typeof value === "string" || typeof value === "boolean"
                        ? value.toString()
                        : value
                    : "N/A" }))));
};
